<template>
  <v-dialog v-model="showMaxEffortConfirmation" width="500" persistent class="z5">
    <v-card>
      <v-card-title class="text-h5 white--text third">
        <span class="d-flex justify-left flex-grow-1">Nombre d'heure atteint</span>
        <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-4 d-flex flex-column">
        <span class="text-subtitle-1">{{ label }}</span>
        <br>
        <span class="text-subtitle-1">Souhaitez-vous tout de même l'affecter ?</span>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn outlined class="ma-2 third--text no-caps-btn" color="white" :disabled="loading" @click="closeModal"> Abandonner </v-btn>
        <v-btn outlined rounded class="ma-2 third--text no-caps-btn" color="white" :loading="loading" @click="handleConfirm">
          <v-icon size="24" color="third" right>mdi-plus</v-icon>
          Ajouter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import store from '@/store';

export default {
  setup () {
    const loading = ref(false);
    const showMaxEffortConfirmation = computed(() => store.state.showMaxEffortModal);

    const label = computed(() => {
      const horsesEffort = store.state.alertEffort ? Object.values(store.state.alertEffort) : [];
      return `Attention, le cheval${horsesEffort.length > 1 ? 's' : ''} ${(horsesEffort || []).map(h => h.horseName).join(', ')} ont atteint le d'heure maximum par jour.`;
    });

    const closeModal = () => {
      store.commit('setShowMaxEffortModal', false);
      store.commit('setAlertEffort', null);
    };

    const handleConfirm = async () => {
      if (store.state.maxEffortCallback) {
        const callback = store.state.maxEffortCallback;
        store.commit('setMaxEffortCallback', null);
        loading.value = true;
        await callback();
        loading.value = false;
      }
      closeModal();
    };

    return {
      showMaxEffortConfirmation,
      closeModal,
      handleConfirm,
      label,
      loading
    };
  }
};
</script>
